module.exports = __webpack_public_path__ + "baab57d5.svg";